/* eslint-disable no-bitwise */

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export const ExportPDF = async data => {
  const result =
    data && data.length
      ? await data.map(file => [
          { text: file.nome, style: 'header' },
          {
            image: file.base64,
            fit: [640, 720],
            pageBreak: 'after',
          },
        ])
      : [];
  const collection = await result.map(item => [...item]);
  const docDefinition = {
    content: [...collection],
    pageOrientation: 'landscape',
    pageMargins: [20, 40, 20, 40],
    pageSize: 'A4',
    styles: {
      header: {
        fontSize: 18,
        bold: true,
        margin: [0, 0, 0, 10],
      },
    },
    defaultStyle: {
      alignment: 'justify',
    },
  };
  const PDF = await pdfMake.createPdf(docDefinition);
  const response = await PDF.download(`${new Date().getTime()}`);
  return response;
};

export const getStatus = (arr, item, isPayment) => {
  const obj = {};
  switch (arr) {
    case 1:
      obj.text = 'Pendente';
      obj.status = 'pending';
      break;
    case 2:
      obj.text = isPayment ? 'Realizado' : 'Aprovado';
      obj.status = 'approved';
      break;
    case 3:
      obj.text = isPayment ? 'Recusado' : 'Reprovado';
      obj.status = 'refused';
      break;
    case 4:
      obj.text = 'Em análise';
      obj.status = 'analysing';
      break;
    case 5:
      obj.text = 'Enviado ao faturamento';
      obj.status = 'fatured';
      break;
    default:
      obj.text = 'Pendente';
      obj.status = 'Pendente';
  }
  return obj[item];
};
